module.exports = __webpack_public_path__ + "static/img/page6.6f63a7b2.jpg";